// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root_nYgVV","label":"Checkbox_label_W1gAg","input":"Checkbox_input_zWYCe"};